import { render, staticRenderFns } from "./CertificateLookup.vue?vue&type=template&id=d398f79e&"
import script from "./CertificateLookup.vue?vue&type=script&lang=js&"
export * from "./CertificateLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports